import parseHTML from '../utils/parseHTML'
import dataLayer from './dataLayer'

if (!window.impressionsOnScroll) {
    window.impressionsOnScroll = {}
}

export default {
    customInformation (trackingLabelPrefix) {
        if (trackingLabelPrefix) {
            window.gtmDataObject.push({
                event: 'customInformation',
                eventRaisedBy: 'FreeHTML',
                eventLabelPrefix: trackingLabelPrefix
            })
        }
    },

    getCurrency (currency) {
        const impressionsOnScroll = window.impressionsOnScroll
        if (!impressionsOnScroll.currency) {
            impressionsOnScroll.currency = currency
        }
        return {
            currencyCode: impressionsOnScroll.currency
        }
    },

    scrollImpression ({ product }) {
        const data = product.data
        this.getCurrency(data.currency)
        return getCategories(product)
            .then(dimension55 => {
                window.impressionsOnScroll[data.internationalId] = buildGTMProductObject(product, dimension55)
            })
    },

    itemDisplay ({ action, type = 'products', element }) {
        if (typeof type === 'string') {
            type = [type]
        }
        window.gtmDataObject.push({
            event: 'itemDisplay',
            eventRaisedBy: 'FreeHTML',
            eventAction: action, // "Click", "Product View", "Menu Dropdown", "Slider Change"
            itemTypes: type,
            rootElement: element
        })
    },

    virtualPageView ({ name, type, category, subCategory, breadcrumbUID, breadCrumbID }) {
        if (breadCrumbID) {
            breadcrumbUID = breadCrumbID
            console.warn('breadCrumbID is deprecated, use breadcrumbUID instead')
        }
        window.gtmDataObject.push({
            event: 'event_virtualPageView',
            eventRaisedBy: 'FreeHTML',
            breadcrumbUID,
            pageName: name,
            pageType: type,
            pageCategory: category,
            pageSubCategory: subCategory,
            segmentBusiness: dataLayer.channel
            // pageTechnology: '{pageTechnology}', // ie: "Original|||Pro|||Vertuo"
            // pageVariant: '{pageVariant}'
        })
    },

    customEvent ({ category, action, label, interaction }) {
        window.gtmDataObject.push({
            event: 'customEvent',
            eventRaisedBy: 'FreeHTML',
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            nonInteraction: interaction
        })
    },

    detailView (products) {
        return Promise
            .all(products.map(getCategories))
            .then(dimensions55 => window.gtmDataObject.push({
                event: 'detailView',
                eventRaisedBy: 'FreeHTML',
                ...this.getCurrency(products[0].data.currency),
                ecommerce: {
                    detail: {
                        actionField: {},
                        products: products.map((product, i) => buildGTMProductObject(product, dimensions55[i]))
                    }
                }
            }))
    },
    productClick ({ products, list }) {
        return Promise
            .all(products.map(getCategories))
            .then(dimensions55 => window.gtmDataObject.push({
                event: 'productClick',
                eventRaisedBy: 'FreeHTML',
                ...this.getCurrency(products[0].data.currency),
                ecommerce: {
                    click: {
                        actionField: {
                            list
                        },
                        products: products.map((product, i) => buildGTMProductObject(product, dimensions55[i]))
                    }
                }
            }))
    },
    addToCart (product, quantity) {
        const metric = {}
        const type = product.data.type
        if (type === 'capsule') {
            metric.metric10 = quantity
        } else if (type === 'machine') {
            metric.metric11 = quantity
        } else if (type === 'accessory') {
            metric.metric12 = quantity
        }
        return getCategories(product)
            .then(dimension55 => window.gtmDataObject.push({
                event: 'addToCart',
                eventRaisedBy: 'FreeHTML',
                ...this.getCurrency(product.data.currency),
                ecommerce: {
                    add: {
                        actionField: {},
                        products: [{
                            ...buildGTMProductObject(product, dimension55),
                            ...metric,
                            quantity
                        }]
                    }
                }
            }))
    }
}

function buildGTMProductObject (product, dimension55) {
    const productData = product.data
    let category
    if (productData.type === 'capsule') {
        category = 'capsules'
    } else if (productData.type === 'accessory') {
        category = 'accessories'
    } else if (productData.type === 'machine') {
        category = 'machines'
    }
    return {
        brand: 'Nespresso',
        category,
        dimension43: 'false',
        dimension44: 'false',
        dimension53: productData.legacyId,
        dimension54: parseHTML(productData.name)[0].textContent,
        dimension55,
        dimension56: productData.technologies ? productData.technologies.map(technology => capitalizeFirstLetter(technology.split('/')[2])).join('|||') : null,
        dimension57: productData.bundled ? 'bundled' : 'single',
        dimension130: productData.productSelections.join('|'),
        id: productData.internationalId,
        name: parseHTML(productData.internationalName)[0].textContent,
        price: productData.price
    }
}

function capitalizeFirstLetter (string) {
    return string[0].toUpperCase() + string.slice(1)
}

function getCategories (product) {
    return Promise
        .all(product.data.supercategories.map(supercategory => window.napi.catalog().getCategory(supercategory)))
        .then(categories => {
            const dimension55 = []
            for (const category of categories) {
                const code = category.code
                if (~code.indexOf('-cupSize-') ||
                    ~code.indexOf('-range-') ||
                    ~code.indexOf('capsule-aromatic-') ||
                    ~code.indexOf('machine-keyFeature-') ||
                    ~code.indexOf('machine-color-') ||
                    ~code.indexOf('accessory-collection-') ||
                    ~code.indexOf('accessory-hero-month')) {
                    dimension55.push(category.name.toLowerCase())
                }
            }
            return dimension55.join('|')
        })
}
